// extracted by mini-css-extract-plugin
export default {"level-1":"level-1-oGPWq","level-2":"level-2-lZuFh","level-3":"level-3-pLe2A"};